import * as z from "zod";
import { gql } from "graphql-request";
import { Image, ImageFragment } from "../image";
import { Sys, SysFragment } from "../sys";

export const NewsEntryVideo = z.object({
  __typename: z.literal("NewsEntryVideo"),
  sys: Sys,
  title: z.string().nullable(),
  videoUrl: z.string().nullable(),
  videoThumbnail: Image.nullable(),
  videoThumbnailEn: Image.nullable(),
});

export type NewsEntryVideo = z.infer<typeof NewsEntryVideo>;

export const NewsEntryVideoFragment = gql`
  fragment NewsEntryVideoFragment on NewsEntryVideo {
    sys {
      ...SysFragment
    }
    title
    videoUrl
    videoThumbnail {
      ...ImageFragment
    }
    videoThumbnailEn: videoThumbnail(locale: "en") {
      ...ImageFragment
    }
  }

  ${ImageFragment}
  ${SysFragment}
`;
